import * as actionTypes from '../actionTypes/referenceModal';

export default {
  toggleReferenceModal: () => ({
    type: actionTypes.TOGGLE_REFERENCE_MODAL,
    payload: {},
  }),
  toggleManualReferenceModal: () => ({
    type: actionTypes.TOGGLE_MANUAL_REFERENCE_MODAL,
    payload: {},
  }),
};
